import { render, staticRenderFns } from "./ChatGPTActionDetail.vue?vue&type=template&id=06bfd588&"
import script from "./ChatGPTActionDetail.vue?vue&type=script&lang=js&"
export * from "./ChatGPTActionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports